export enum PartnerFilterKey {
  name = 'name',
  status = 'status',
  industry = 'industry',
}

export enum PricingConfigsFilterKey {
  name = 'name',
  partnerId = 'partner_id',
}

export enum TransactionFilterKey {
  transactionId = 'transaction_id',
  transactionType = 'transaction_type',
  transactionFlow = 'transaction_flow',
  partnerId = 'partner_id',
  transactionState = 'transaction_state',
  transactionCreatedBetween = 'transaction_created_between',
  actionRequired = 'action_required',
  onlyExpired = 'only_expired',
  originApp = 'origin_app',
}
